import { useEffect, useMemo, useState } from 'react';
import { LoadOptions } from 'ui';
import { optionTypes } from 'ui/common/select/constants';
import { optionsToHierarchy } from 'ui/common/select/hierarchy-options/options-to-hierarchy';
import { SelectItem } from 'ui/common/select/types';

export function useProcessedOptions(
  options: SelectItem[], loadOptions: LoadOptions,
  categoryOptions: SelectItem[], loadCategoryOptions: LoadOptions,
  descriptionAllLevels: boolean, displayCategories: boolean, 
  selectedCategoryId: number | undefined
) {
  return useMemo(() => {
    const {
      breadcrumbStack: categoryBreadcrumbStack,
      returnedOptions: returnedCategoryOptions 
    } = optionsToHierarchy({
      originOptions: categoryOptions,
      loadOptions: {
        parentId: displayCategories && selectedCategoryId 
                    ? selectedCategoryId 
                    : loadCategoryOptions.parentId
      },
      descriptionAllLevels,
      linkType: optionTypes.CATEGORY_OPTION
    });

    const {
      returnedOptions, breadcrumbStack: optionsBreadcrumbStack, allLevelsDescriptionPrefix
    } = optionsToHierarchy({
      originOptions: options,
      loadOptions,
      descriptionAllLevels,
      linkType: optionTypes.OPTION
    });

    const mergedBreadcrumbStack = displayCategories
                  ? [
                      ...categoryBreadcrumbStack,
                      ...(!selectedCategoryId 
                            ? [] // We do not want any options in the breadcrumb
                                 // if we are still browsing for a categoryOption
                            : optionsBreadcrumbStack.slice(1)
                      )
                    ]
                  : optionsBreadcrumbStack;

    return {
      breadcrumbStack: mergedBreadcrumbStack,
      returnedOptions,
      allLevelsDescriptionPrefix,
      returnedCategoryOptions
    };
  }, [options, loadOptions, categoryOptions, 
      loadCategoryOptions, descriptionAllLevels,
      displayCategories, selectedCategoryId]);
}

export function useShowLongDescriptionState(externalValue: boolean) {
  const [showLongDescription, setShowLongDescrption] = useState(externalValue);

  useEffect(() => {
    // If the external value (eg. prop) changes, it should immediately override state
    setShowLongDescrption(externalValue);
  }, [externalValue]);
  
  return {
    showLongDescription,
    onShowLongDescription: setShowLongDescrption
  };
}
